import React, {Component} from 'react';

class StationEntry extends Component {
    constructor(props) {
        super(props);
        this.state = {
            stations: [],
            st_name: '',
            st_ip: '',
            editId: null,
            error: '',
            success: '',
            userId: localStorage.getItem('userId'),
            userName: localStorage.getItem('userName'),
            userToken: localStorage.getItem('userToken')
        };
        this.getStations = this.getStations.bind(this);
    }

    componentDidMount() {
        this.getStations();
    }

    getStations = () => {
        fetch(process.env.REACT_APP_NODE_ROOT_URL + '/timeclock/stations', {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'bwToken': this.state.userToken
            }
        })
        .then(res => res.json())
        .then(stations => this.setState({ stations }));
    }

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    handleEdit = (station) => {
        this.setState({
            st_name: station.st_name,
            st_ip: station.st_ip,
            editId: station.st_id,
            error: '',
            success: ''
        });
    }

    handleDelete = (id) => {
        if (!window.confirm('Delete this station?')) return;
        fetch(process.env.REACT_APP_NODE_ROOT_URL + '/timeclock/station/' + id, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'bwToken': this.state.userToken
            }
        })
        .then(res => res.json())
        .then(result => {
            if (result.success) {
                this.setState({ success: 'Station deleted!', error: '' });
                this.getStations();
            } else {
                this.setState({ error: result.error || 'Error deleting station', success: '' });
            }
        })
        .catch(() => this.setState({ error: 'Error deleting station', success: '' }));
    }

    handleSubmit = (e) => {
        e.preventDefault();
        const { st_name, st_ip, userToken, editId } = this.state;
        if (!st_name || !st_ip) {
            this.setState({ error: 'Station name and IP are required', success: '' });
            return;
        }
        const url = process.env.REACT_APP_NODE_ROOT_URL + '/timeclock/station' + (editId ? '/' + editId : '');
        const method = editId ? 'PUT' : 'POST';
        fetch(url, {
            method,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'bwToken': userToken
            },
            body: JSON.stringify({ st_name, st_ip })
        })
        .then(res => res.json())
        .then(result => {
            if (result.success) {
                this.setState({ success: editId ? 'Station updated!' : 'Station saved!', error: '', st_name: '', st_ip: '', editId: null });
                this.getStations();
            } else {
                this.setState({ error: result.error || 'Error saving station', success: '' });
            }
        })
        .catch(() => this.setState({ error: 'Error saving station', success: '' }));
    }

    handleCancelEdit = () => {
        this.setState({ st_name: '', st_ip: '', editId: null, error: '', success: '' });
    }

    render() {
        return (
            <div id="main">
                <div className="page-wrapper">
                    <div className="row page-titles">
                        <div className="col-md-5 align-self-center">
                            <h3 className="text-primary">Stations</h3>
                            <hr/>
                            <form onSubmit={this.handleSubmit} className="form-inline">
                                <input type="text" name="st_name" value={this.state.st_name} onChange={this.handleChange} placeholder="Station Name" className="form-control mr-2" />
                                <input type="text" name="st_ip" value={this.state.st_ip} onChange={this.handleChange} placeholder="IP Address" className="form-control mr-2" />
                                <button type="submit" className="btn btn-info btn-sm">{this.state.editId ? 'Update' : 'Add/Update'} Station</button>
                                {this.state.editId && <button type="button" className="btn btn-secondary btn-sm ml-2" onClick={this.handleCancelEdit}>Cancel</button>}
                            </form>
                            {this.state.error && <div className="alert alert-danger mt-2">{this.state.error}</div>}
                            {this.state.success && <div className="alert alert-success mt-2">{this.state.success}</div>}
                        </div>
                        <div className="col-md-7 align-self-center">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><a href="/">Home</a></li>
                                <li className="breadcrumb-item active">Stations</li>
                            </ol>
                        </div>
                    </div>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="table-responsive">
                                            <table className="table">
                                                <thead>
                                                    <tr>
                                                        <th>&nbsp;</th>
                                                        <th>ID</th>
                                                        <th>Name</th>
                                                        <th>IP Address</th>
                                                        
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.stations.map(station => (
                                                        <tr key={station.st_id}>
                                                            <td>
                                                                <button className="btn btn-info btn-sm" onClick={() => this.handleEdit(station)}>Edit</button>
                                                                <button className="btn btn-info btn-sm" onClick={() => this.handleDelete(station.st_id)}>Delete</button>
                                                            </td>
                                                            <td>{station.st_id}</td>
                                                            <td>{station.st_name}</td>
                                                            <td>{station.st_ip}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default StationEntry;
